import styled from 'styled-components';
import ReactSelect from 'react-select';

export const StyledReactSelect = styled(ReactSelect)`
  margin: 0;

  .select__dropdown-indicator {
    color: black;
  }

  .select__value-container {
    padding: 6px 8px;
  }

  .select__multi-value {
    background: rgba(230, 242, 255, 1);
    font-weight: 500;
    padding: 7px;
    border-radius: 5px;
  }
`;
